<template>

	<div v-if="!$mq.mobile" class="nav">
		<div class="nav__title">
			<slot name="navTitle" />
		</div>
		<div class="nav__list">
			<slot name="navList" />
		</div>
	</div>

</template>

<script>

	export default {
		name: "SectionNav"
	}

</script>

<style lang="scss" scoped>

	@import "media.scss";
	@import "list-style-reset.scss";
	@import "button-reset.scss";
	@import "responsive-font.scss";
	@import "container.scss";

	.nav {
		@include container;
		display:flex; justify-content:space-between; border-bottom:1px solid rgba(#09253B, .12);
		&__title {
			@include responsive-font(30);
			text-transform:uppercase; font-family:"Oswald"; font-weight:400; color:#3D3D3D; line-height:1.28; margin:.3rem 0 .6rem;
			mark {
				color:#FDB913; display:inline-block;
			}
		}
		button {
			@include button-reset;
			@include responsive-font(18);
			line-height:1.529; font-weight:400; color:#6D6E71; cursor:pointer; height:100%;
			&:hover {
				color:#FDB913;
			}
		}
		ul {
			@include list-style-reset;
			display:flex; height:100%;
		}
		li {
			position:relative;
			&.active {
				&:after {
					content:''; border-bottom:3px solid #FDB913; width:100%; height:3px; position:absolute; bottom:0; right:0;
					transform:translateY(25%);
				}
			}
			& + li {
				margin-left:3rem;
			}
		}

	}

</style>



// WEBPACK FOOTER //
// src/components/Products/SectionNav.vue